import React from "react";
import { useTranslation } from "react-i18next";
import Tooltip from "../Tooltip";

export const DownloadButton = (props) => {
  const { title = "container.general_words.download", onClick, disabled = false, stopPropagation } = props;
  const { t } = useTranslation();

  const onBtnClick = (e) => {
    e.preventDefault();

    if (stopPropagation) {
      e.stopPropagation();
    }

    if (disabled) {
      return;
    }

    onClick?.();
  };

  return (
    <Tooltip title={t(title)} placement="top">
      <button
        type="button"
        disabled={disabled}
        onClick={onBtnClick}
        className="text-muted"
        style={{ background: "none", border: "none", padding: 0, cursor: disabled ? "not-allowed" : "pointer" }}
      >
        <i className="ti-download" />
      </button>
    </Tooltip>
  );
};
